import { setAutoFreeze } from 'immer';

/**
 * Immer freezes produced state by default. Frozen trees + later `produce` recipes can surface
 * as read-only property errors (e.g. batch updates). Import this module before any other code that
 * uses Immer — especially app entrypoints, where hoisted imports run before inline `setAutoFreeze`.
 */
setAutoFreeze(false);
